var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container card"},_vm._l((_vm.data),function(tab,index){return _c('div',{key:index},_vm._l((tab.data),function(item,index){return _c(item.type,{key:index,tag:"component",attrs:{"canvas":_vm.that,"prop":item.prop,"view-only":""}})}),1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }